import React from 'react'

export const Navbar = () => {
    return (
        <nav className="navbar__nav navbar navbar-expand-sm navbar">            
            <img alt="Mediaset" className="navbar__logo" src="https://files.mediaset.es/cimg/1001/2019/10/01/mediasetespana-claro_b1d0.svg?w=undefined" ></img>
        </nav>
    )
}